export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7051.4d8ae16f.jpg";